import { v4 as uuidv4 } from 'uuid';
import { assignCoverPhotos } from '../../../../commons/utils/assignCoverPhotos';
import { getWhatshotPublishersAPI } from './api';

const WHATS_HOT_LIMIT = 25;

async function getWhatshotPublishers() {
    this.observed.whatshotPublishersLoading = true;
    try {
        const session = this.env.session;
        const traceId = this.env.traceId;

        const res = await getWhatshotPublishersAPI({ token: session?.token, traceId });

        const publishers = res?.data?.data?.publishers || res?.data?.publishers || [];

        this.whatshotPublishers = assignCoverPhotos(publishers).slice(0, WHATS_HOT_LIMIT);

        this.whatsHotPublisherIds = {};
        this.whatshotPublishers.forEach((p) => {
            // Carry the rank through so tiles outside What's Hot can show "#N" too;
            // falls back to `true` if the API didn't include a rank for this item.
            this.whatsHotPublisherIds[String(p.pubId)] = p.rank ?? true;
        });
        this.observed.whatshotPublishers = uuidv4();
        this.applyDirectoryFilter();
    } finally {
        this.observed.whatshotPublishersLoading = false;
    }
}

export default getWhatshotPublishers;
